// extracted by mini-css-extract-plugin
export var indeterminate = "_5v-5";
export var md = "_5v-4";
export var semantic = "_5v-6";
export var sm = "_5v-3";
export var text = "_5v-7";
export var toggleInput = "_5v-0";
export var toggleSwitch = "_5v-1";
export var xs = "_5v-2";